var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.value + item.disable,staticClass:"list-item",class:[
      ( Array.isArray(_vm.value)?_vm.value.includes(item.value):_vm.value===item.value)?'active':'',
      item.disable?'disabled': ''
    ],on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._t("default",null,{"row":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }